import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { Bodytext, ContinuousProgressBarV2 } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'

import themeValues from 'theme'

import {
  ConsiderationsContainer,
  ConsiderationsHeading,
  ConsiderationsIconTextContainer,
  ConsiderationsRiskBarContainer,
  ConsiderationsRiskBarHeader,
  StyledCheckmark,
} from '../../styled-components'

type Props = {
  risk: string
}

const ConsiderationsContent = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()

  const RiskConsiderationStrings = [
    getRemoteString({
      key: `portfolio.risk.considerations_one.${props.risk}`,
    }),
    getRemoteString({
      key: `portfolio.risk.considerations_two.${props.risk}`,
    }),
    getRemoteString({
      key: `portfolio.risk.considerations_three.${props.risk}`,
    }),
    getRemoteString({
      key: `portfolio.risk.considerations_four.${props.risk}`,
    }),
  ]

  const ProgressBarValues: { [key: string]: any } = {
    conservative: 17,
    moderately_conservative: 34,
    moderate: 51,
    moderately_aggressive: 68,
    aggressive: 85,
  }

  const progressBarColor =
    props.risk === 'aggressive' || props.risk === 'moderately_aggressive'
      ? themeValues.colors.sunrise
      : themeValues.colors.purple

  return (
    <ConsiderationsContainer>
      <ConsiderationsRiskBarContainer>
        <ConsiderationsRiskBarHeader>Risk</ConsiderationsRiskBarHeader>
        <ContinuousProgressBarV2
          max={100}
          value={ProgressBarValues[props.risk]}
          backgroundColor={progressBarColor}
          height={20}
          maxLabel="High"
          minLabel="Low"
          labelPosition="5px"
        />
      </ConsiderationsRiskBarContainer>
      <ConsiderationsHeading>
        {getRemoteString({
          key: 'portfolio.risk.considerations.consider',
        })}
      </ConsiderationsHeading>
      {RiskConsiderationStrings.map((element) => (
        <>
          {element.length > 0 && (
            <ConsiderationsIconTextContainer>
              <StyledCheckmark
                icon={AcornsIcon.Icon.Checkmark}
                width="15px"
                height="11px"
              />
              <Bodytext>{element}</Bodytext>
            </ConsiderationsIconTextContainer>
          )}
        </>
      ))}
    </ConsiderationsContainer>
  )
}

export default ConsiderationsContent
